<template>
  <div class="fireBook">
    <div class="smokeAlarmAuto">
      <div class="proOrder" style="text-align: center; margin-bottom: 30px">
        电动车报警调度派单  
      </div>
      <div style="text-align: center">
        <!-- <img src="~@/assets/img/smoke_f.png" alt="">
                <img src="~@/assets/img/twoLight.png" alt="" style="margin:0 77px;">
                <img src="~@/assets/img/threeLight.png" alt=""> -->
      </div>
    </div>
    <div class="fireBookBox">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane name="first" v-if="!onlyShowSecond">
          <template slot="label">
            <img
              src="~@/assets/img/fireDoc.png"
              style="vertical-align: middle"
              alt=""
            />
          </template>
          <div class="police" style="padding-left: 64px">
            <el-timeline>
              <el-timeline-item
                placement="top"
                v-for="(item, index) in timelines"
                :key="index"
                :timestamp="item.createAt"
              >
                <div class="fireText" v-if="item.reportType == 1">
                  <el-row :gutter="20">
                    <el-col :span="8"
                      ><span>{{ item.createTime }}</span></el-col
                    >
                    <el-col :span="10"
                      ><span>{{ item.msg }}</span></el-col
                    >
                    <el-col :span="6"
                      ><span>{{ item.deptName }}</span></el-col
                    >
                  </el-row>
                </div>
                <div
                  class="fireText"
                  v-if="
                    item.reportType == 2 &&
                    item.imgList &&
                    item.imgList.length > 0
                  "
                >
                  <el-col :span="8"
                    ><span>{{ item.createTime }}</span></el-col
                  >
                  <el-col :span="10">
                    <el-image
                      :src="imgItem"
                      v-for="(imgItem, ydex) in item.imgList"
                      :key="ydex"
                      style="width: 100px; height: 100px"
                    ></el-image
                  ></el-col>
                  <el-col :span="6"
                    ><span>{{ item.deptName }}</span></el-col
                  >
                </div>
                <div class="fireText" v-if="item.reportType == 2 && item.video">
                  <el-col :span="8"
                    ><span>{{ item.createTime }}</span></el-col
                  >
                  <el-col :span="10"
                    ><span
                      ><video
                        :src="item.video"
                        controls="controls"
                      ></video></span
                  ></el-col>
                  <el-col :span="6"
                    ><span>{{ item.deptName }}</span></el-col
                  >
                </div>
                <div class="fireText" v-if="item.reportType == 5">
                  <h4>{{ item.location }}</h4>
                  <gaodemap
                    :lng="item.longitude"
                    :lat="item.dimensionality"
                  ></gaodemap>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div
            class="policeInfo"
            style="padding-top: 10px; border-top: 1px solid #fff"
          >
            <el-form
              ref="form"
              v-model="form"
              :inline="true"
              class="demo-form-inline"
              v-if="canOper"
              label-width="100px"
            >
              <el-row :gutter="32">
                <el-col :span="18">
                  <el-form-item label="调度内容:">
                    <el-input
                      v-model="form.msg"
                      style="width: calc(25vw); height: 52px"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item>
                    <span
                      ><img
                        src="~@/assets/img/reply.png"
                        alt=""
                        @click="sendMessage"
                    /></span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-upload
                class="upload-demo"
                action=""
                multiple
                style="margin-left: 100px; color: #edec70"
                :http-request="uploadHttp"
                :file-list="fileList"
              >
                <el-button size="small" type="text">图片/视频</el-button>
              </el-upload>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <template slot="label">
            <img
              src="~@/assets/img/taskDet.png"
              style="vertical-align: middle"
              alt=""
            />
          </template>
          <div class="taskDetail" style="padding: 0 40px">
            <el-form label-width="120px" label-position="right">
              <el-form-item label="警情编码："
                ><span>{{ selectRow.alarmSingle.id }}</span></el-form-item
              >
              <el-form-item label="持续时间："
                ><span>{{
                  selectRow.alarmSingle.closingacaseTime
                }}</span></el-form-item
              >
              <el-form-item label="出动单位："
                ><span>{{ selectRow.deptDO.name }}</span></el-form-item
              >
              <el-form-item label="报警时间："
                ><span>{{
                  selectRow.alarmSingle.alarmTime
                }}</span></el-form-item
              >
              <el-form-item label="灾害地址："
                ><span>{{
                  selectRow.alarmSingle.disasterAddress
                }}</span></el-form-item
              >
              <el-form-item label="接警时间："
                ><span>{{
                  selectRow.alarmSingle.reportTime
                }}</span></el-form-item
              >
              <el-form-item label="是否电话处置：">
                <span v-if="selectRow.alarmSingle.disposeState == '1'">是</span>
                <span v-if="selectRow.alarmSingle.disposeState != '1'">否</span>
              </el-form-item>
              <el-form-item label="现场到达时间："
                ><span>{{
                  selectRow.alarmSingle.arrivalTime
                }}</span></el-form-item
              >
              <el-form-item label="完成报告时间："
                ><span>{{ selectRow.alarmSingle.closingTime }}</span>
              </el-form-item>
              <el-form-item label="战斗员人数："
                ><span>{{ selectRow.alarmSingle.participateNumber }}</span>
              </el-form-item>
              <el-form-item label="出动装备数量："
                ><span>{{ selectRow.alarmSingle.equipmentNumber }}</span>
              </el-form-item>

              <el-row :gutter="32" v-if="canOper" style="text-align: center">
                <el-col :span="24">
                  <img
                    src="~@/assets/img/subRep.png"
                    @click="submitReport"
                    alt=""
                  />
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="three" v-if="!onlyShowSecond">
          <template slot="label">
            <img
              src="~@/assets/img/warPer.png"
              style="vertical-align: middle"
              alt=""
            />
          </template>
          <el-table :data="taskUserList" class="fireProbeTable">
            <el-table-column label="所属单位" prop="msg"> </el-table-column>
            <el-table-column label="姓名" prop="name"> </el-table-column>
            <el-table-column label="联系电话" prop="phone"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="callPerson(scope.row.phone)"
                  >呼叫</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      class="endNoticeDialog"
      :visible.sync="dialog.handAlarmVisible"
      width="30%"
      title="出动总结"
      append-to-body
      center
      show-close
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="content"
        maxlength="30"
        rows="10"
        show-word-limit
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" size="small" @click="auditInfo">审核</el-button> -->
        <span
          >
                    <el-button
        @click="auditInfo()"
        style="
          width: 206px;
          height: 43px;
          background: #0080db;
          border-radius: 22px;
        " round
        type="primary"
        ><label style="font-size: 18px; font-weight: bold; color: #ffffff">
          提交
        </label></el-button>
         </span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import gaodemap from "@/pages/gaodemap/gaodemap";
export default {
  name: "fireBook",
  components: {
    gaodemap,
  },
  props: ["alarmId"],
  data() {
    return {
      form: { msg: "" },
      fileFormData: {},
      timelines: [],
      fileList: [],
      onlyShowSecond: this.$store.state.onlyShowSecond,
      activeName: "first",
      canOper: this.$store.state.canOper,
      dialog: {
        handAlarmVisible: false,
      },
      content: "",
      taskUserList: [],
      subRep: this.$store.state.subRep,
    };
  },
  watch: {},
  created() {
    let _this = this;
    _this.queryProbeInfo();
    this.queryFireDoucment();
    setInterval(()=>_this.queryFireDoucment(),2000);
  },
  mounted() {
    let _this = this;
    _this.fileFormData = new FormData();
  },
  methods: {
    queryProbeInfo() {
      let _this = this;
      let success = function (resp) {
        _this.selectRow = resp;
         if(resp.alarmSingle.closingacaseState == '0' || resp.alarmSingle.closingacaseState == '3'){
          _this.duractionTime(resp.alarmSingle.closingacaseTime);
        }
      };
      _this.http.get("/webapi/probe/findProbe/" + _this.alarmId, {}, success);
    },
    
    duractionTime(timeAction) {
      console.log(timeAction)
      let _this = this;
      if (timeAction != null) {
        _this.selectRow.alarmSingle.closingacaseTime = timeAction;
      } else {
        let timestamp = new Date().getTime();
        let oldTime = new Date(
          _this.selectRow.alarmSingle.alarmTime
        ).getTime(); //得到毫秒数
        let total = (timestamp - oldTime   ) / 1000;
        let day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        let afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
        let hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
        let afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
        let min = parseInt(afterHour / 60); //计算整数分
        let afterMin = parseInt(
          total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60
        ); //取得算出分后剩余的秒数
        let seconds = Math.round(afterMin / 1000);
        _this.timeAll =
          day + "天 " + hour + "小时 " + min + " 分钟" + afterMin + " 秒";
        _this.selectRow.alarmSingle.closingacaseTime = _this.timeAll;
      }
    },



    handleTabClick(tab, event) {
      let _this = this;
      if (tab.name === "first") {
        //火场文书
        _this.$store.commit("updateSelectFireBookActive", "first");
        _this.queryFireDoucment();
      } else if (tab.name === "second") {
        //任务详情
        // _this.$store.commit('updateSelectFireBookActive','second');
      } else if (tab.name === "three") {
        //战斗组成员
        // _this.$store.commit('updateSelectFireBookActive','three');
        _this.queryTaskUserList();
      }
    },
    sendMessage() {
      let _this = this;
      _this.fileFormData.append("taskId", _this.alarmId);
      _this.fileFormData.append("msg", _this.form.msg);
      let success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success(resp.msg);
          _this.form.msg = "";
          _this.fileList = [];
          _this.fileFormData = new FormData();
        } else {
          _this.$message.error(resp.msg);
        }
      };
      _this.http.postFile(
        "/webapi/writ/taskReportSave",
        _this.fileFormData,
        success
      );
    },

   
    

         
    queryFireDoucment() {
      //查询火场文书内容
      let _this = this;
      let success = function (resp) {
        _this.timelines = resp.data;
      };
      _this.http.get("/webapi/writ/taskReport/" + _this.alarmId, {}, success);
    },
    uploadHttp(param) {
      let _this = this;
      var fileType = param.file.type.split("/")[0];
      if (fileType === "image") {
        //图片
        _this.fileFormData.append("filePath", param.file);
      } else if (fileType === "video") {
        //视频
        _this.fileFormData.append("videoPath", param.file);
      } else {
        _this.$message.warning("格式不正确");
      }
    },
    submitReport() {
      //提交总结报告
      let _this = this;
      _this.dialog.handAlarmVisible = true;
    },
    auditInfo() {
      let _this = this;
      _this.dialog.handAlarmVisible = false;
      if (!_this.content) {
        _this.$message.warning("请输入审核内容");
        return;
      }
      var data = {
        content: _this.content,
        id: _this.alarmId,
      };
      var success = function (resp) {
        if (resp.code === "0") {
          _this.dialog.handAlarmVisible = false;
          _this.$emit("closeSmokeAlarm");
          _this.$message.success("提交成功！");
          _this.dialog.handAlarmVisible = false;
          _this.$emit("closeFireProbe");
        } else {
          _this.$message.error("提交失败！");
        }
      };
      _this.http.post("/webapi/writ/submitAudit", data, success);
    },
    queryTaskUserList() {
      let _this = this;
      let success = function (resp) {
        _this.taskUserList = resp;
      };
      _this.http.get(
        "/webapi/writ/taskUserList",
        { taskId: _this.alarmId },
        success
      );
    },
    callPerson(phone) {
      let _this = this;
      let success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success(resp.msg);
        }
      };
      _this.http.post("/webapi/writ/voiceCalls", { phone: phone }, success);
    },
  },
};
</script>

<style lang="less">
.fireBook {
  .el-main {
    height: calc(50vh);
  }

  .policeOutNum {
  }

  .el-table tr td:nth-child(1) {
    color: #fff !important;
  }
  .el-table tr th {
    display: none;
  }
  .el-table tr td,
  .el-table tr th {
    color: #b4b4b4 !important;
    border-bottom: 0px;
    background: #3b3b3b !important;
  }

  .el-tabs__nav-wrap {
    border-radius: 16px;
    // background-color: white !important;
    -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
  }

  .el-dialog__title {
    color: #fff;
    line-height: 30px;
    text-shadow: 1px 2px 10px rgba(4, 0, 0, 0.7);
  }

  .fireBookBox {
    .el-tabs__header {
      margin: 0px;
      border: 1px solid #fff;
    }

    .police,
    .taskDetail,
    .policeOutNum {
      border: 1px solid #fff;
      border-top: 0px;
    }

    border-radius: 16px;

    .el-tabs__active-bar {
      height: 7px;
      background: #ebeb6c;
      border-radius: 4px;
    }

    .el-tabs__nav {
      line-height: 64px;
      height: 64px;
      padding-top: 15px;
    }

    .taskDetail {
      color: #fff;

      .el-form-item__label {
        color: #fff;
      }
    }

.fireDoc{
.el-dialog__header {
  background-color: #0080DB;
 .el-dialog__title {
  color: rgb(247, 247, 247);
}
}
} 
  }
}

.j-police {
  margin: 10px auto 0px;
  width: auto;
  border-radius: 0px;
}
</style>


// WEBPACK FOOTER //
// src/pages/fireBook/fireProbe.vue